import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getHeaders } from "../../utils/requestHeaders";
import { API_HOST } from "../../utils/constants";
import { buildMutationHelper } from "../../utils/buildMutationHelper";
import { defaultFromState } from "../../utils/defaultFromState";
import { setExternalSources } from "../reducer/externalSources";

export const externalSourcesApi = createApi({
  reducerPath: "externalSourcesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_HOST,
  }),

  endpoints: (builder) => ({
    getExternalSourcesList: buildMutationHelper(
      builder,
      ({
        page = undefined,
        itemsPerPage = undefined,
        pagination = undefined,
        module = undefined,
      } = {}) => {
        return {
          url: "/external-sources",
          params: {
            page: page,
            itemsPerPage: itemsPerPage,
            pagination: pagination,
            module: module,
          },
          method: "GET",
          headers: getHeaders(),
          defaultFromState: (getState, args) => {
            const {
              externalSources: { page, itemsPerPage, pagination, module },
            } = getState();

            let stateParams = {
              page,
              itemsPerPage,
              pagination,
              module,
            };

            return defaultFromState(stateParams, args);
          },
        };
      },

      (response, dispatch) => {
        if (
          new URL(response?.meta?.request?.url).searchParams.get(
            "pagination"
          ) === null
        ) {
          const { data } = response?.data;
          const totalCount = response?.data?.totalItems;
          dispatch(
            setExternalSources({
              data,
              totalCount,
              errorMessage: "",
            })
          );
        } else {
          const exportData = response?.data;
          dispatch(
            setExternalSources({
              exportData,
              errorMessage: "",
            })
          );
        }
      },

      ({ error }, dispatch) => {
        dispatch(setExternalSources({ errorMessage: error?.data?.error }));
      }
    ),
    getExternalSourcesBusinessList: buildMutationHelper(
      builder,
      (id) => ({
        url: `/organization/external-source/${id}/businesses`,
        method: "GET",
        headers: getHeaders(),
      }),
      (response, dispatch) => {
        const { data } = response?.data;
        dispatch(
          setExternalSources({
            externalSourcesData: data,
            errorMessage: "",
          })
        );
      },
      ({ error }, dispatch) => {
        dispatch(setExternalSources({ errorMessage: error?.data?.error }));
      }
    ),
    getProjectExternalLocationList: buildMutationHelper(
      builder,
      (id) => ({
        url: `/organization/external-source/${id}/project-external-locations`,
        method: "GET",
        headers: getHeaders(),
      }),
      (response, dispatch) => {
        const { data } = response?.data;
        dispatch(
          setExternalSources({
            externalSourcesData: data,
            errorMessage: "",
          })
        );
      },
      ({ error }, dispatch) => {
        dispatch(setExternalSources({ errorMessage: error?.data?.error }));
      }
    ),
    syncTnaEndUser: buildMutationHelper(
      builder,
      ({ endUserData }) => ({
        url: `/organization/external-source/sync-tna-endusers`,
        method: "POST",
        body: endUserData,
        headers: getHeaders(),
      }),
      (response, dispatch) => {
        const { data } = response?.data;
        const totalCount = response?.data?.total;
        dispatch(
          setExternalSources({
            data,
            totalCount,
            errorMessage: "",
          })
        );
      },
      ({ error }, dispatch) => {
        dispatch(setExternalSources({ errorMessage: error?.data?.violations }));
      }
    ),
  }),
});
export const {
  useGetExternalSourcesListMutation,
  useGetExternalSourcesBusinessListMutation,
  useGetProjectExternalLocationListMutation,
  useSyncTnaEndUserMutation,
} = externalSourcesApi;
